export const routes = (prefix = `admissions`) => [
    {
        path: `/${prefix}/admission-queue`,
        name: `${prefix}.admission-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.admission-queue.index`,
                PageDescription: "Admissions - Admission Queue",
            },
        },
    },
];
